<template>
    <div class="main">

      <ProgressBar/>

      <section class="section">

        <h2>Zo reanimeer je</h2>

        <p class="text-blue">Bij een hartstilstand is het belangrijk te reanimeren. Dat doe je zolang de hulpdiensten er niet zijn. Bekijk hier hoe je reanimeert.</p>

        <div v-if="screen" class="lottie-3">
        <Vue3Lottie animationLink="https://lottie.host/53aa4a72-4770-46db-ae9d-bc9641688839/CyXdbSpxh3.json"/>
        </div>

        
        <iframe src="https://www.youtube.com/embed/wSTPMNE4lZ0"
        width="90%" height="215px" 
        title="YouTube video player" frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen allow-same-origin></iframe>

      </section>
     
      <section class="click-section">
        <Clickheart class="click-heart" @click="redTransition()"/>

    <div id="circle-red"></div>

  <!-- <div id="circle-yellow"></div>
   -->

    </section>

    </div>
</template>
<script>

import ProgressBar from "./progress-bar.vue";
import Clickheart from "./click-heart.vue"; 
  
  export default {
    name: 'Scene3-yellow',
    components: {
        ProgressBar,
        Clickheart
    },
    data(){
      return{
        screen: false,
      }
    },
    mounted(){
      this.updateLottie();
      window.addEventListener("resize", this.updateLottie);
      this.$gtm.trackView('zo reanimeer je', '/rea');  
    },
    unmounted(){
      window.removeEventListener("resize", this.updateLottie);
    },
    methods:{
      updateLottie(){
        let screenwidth =  document.body.clientWidth;
        if (screenwidth >= 900) {
        this.screen = true;
      }else{
        this.screen = false;}
      },
      async redTransition() {
      //  console.log('start transition');
        let cirlce = document.getElementById("circle-red");
        cirlce.style.opacity=1;
        cirlce.style.transform="scale(55,55)";
        await new Promise(resolve => setTimeout(resolve, 1000));
        this.$router.push({ path: '/end' });
        // console.log("transitioned")
      }
    }}
</script>
<style scoped>

iframe{
  position: relative;
  z-index: 5;
  opacity: 0;
  animation: appear 1s ease-in-out 0.4s forwards;
}
.main{
    background-color: var(--color-yellow);
}
header{
    display: grid;
    columns: 4;
    animation: appear 1s ease-in-out forwards;
}
h2{
    color: var(--color-red);
    margin-top: 10px;
    margin-bottom: 10px;
    opacity: 0;

    animation: appear 1s ease-in-out 0.1s forwards;
}
.text-blue{
    margin-top: 0;
    color: var(--color-dark-blue);
    font-weight: 500;
    font-size: 15px;
    animation: appear 1s ease-in-out 0.3s forwards;
}

.lottie-3{
  position: absolute;
  bottom: 4%;
  left: 0;
    max-width: 500px;
    width: 110%;
    opacity: 0;
    animation: appear 1s ease-in-out 0.5s forwards;

}

/* .click-section{
    opacity: 0;
    animation: appear 1s ease-in-out 0.5s forwards;
} */
#circle-red{
  position: absolute;
  opacity: 0;
  z-index: 15;
  
  bottom: 12%;
  background-color: var(--color-red);
  border-radius: 50%;

  width: 50px;
  height: 50px;

  left: 50%;
  transform: translateX(-50%);

  transition: transform 0.9s ease-in;
  
  }
  @media (min-width: 900px){
h2{
  font-size: 3.125rem;
  
}
.section{
    align-items: stretch;
    margin-left: 5%;
    margin-top: 10%;
    max-width: 50%

  }
.text-blue{
    max-width: 670px;
    font-size: 1.875rem;
    /* color: var(--color-purple); */
  
  }
iframe{
position: absolute;
right: 3%;
top: 30%;

max-width: 800px;
width: 40%;
max-height: 450px;
height: 40%;
}

#circle-red{
  left: 40%;
  bottom: 14%;
}
  }

</style>